import React from 'react';

const Features = () => {
  const features = [
    {
      icon: '༄',
      title: 'Authentic Sources',
      description: 'Every response rooted in original Sanskrit with scholarly translations'
    },
    {
      icon: '☸',
      title: 'Living Wisdom',
      description: 'Ancient teachings applied to contemporary life with deep understanding'
    },
    {
      icon: '✦',
      title: 'Sacred Preservation',
      description: 'Digital immortality for texts that have guided humanity for millennia'
    }
  ];

  return (
    <section className="features">
      <div className="section-header">
        <h2>Sacred Technology</h2>
        <div className="section-divider"></div>
      </div>
      
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature">
            <div className="feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features; 